module.exports = __webpack_public_path__ + "static/media/user_icon.6ed6a05a.svg";